//** Import Modules */
import axios from "axios";

//** This component is meant to specify the general axios main API endpoint URL */
export default function axiosGeneral() {
  return axios.create({
    baseURL: process.env.REACT_APP_BE_API_URL,
  });
}
